import useRequestTable from 'app/hooks/useRequestTable'

import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    CommentType,
} from 'app/shared-components/CommentsLog/CommentsLog.types'

import requestConfig from 'app/requests/LongTermLease/LongTermLeaseComment.requests'

const useGetLongTermLeaseComments = (longTermLeaseId: number) => {
    return useRequestTable<CommentType>({
        key: RequestKeys.getLongTermLeaseComments,
        params: {
            longTermLeaseId,
        },
        config: requestConfig.filterRequestAll,
        keepPreviousData: true,
    })
}

export default useGetLongTermLeaseComments
